import { Col, Row } from 'antd'
import { Card, Icon, LoadingSpinner, Modal, ButtonGroup, Tooltip } from 'pepsico-ds'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";

import ModalFilters from './ModalFilters';
import ArchletLineChart from '../Charts/ArchletChart/ArchletLineChart';
import PriceChangeBarChart from '../Charts/ArchletChart/PriceChangeBarChart';
import { formatNumberWithCommas, splitValueWithUnit, returnHyphenIfNull, splitNumericValue } from '../../utils/utils'
import { localStoreKeys } from '../../constants/localStoreKeys';
import Legend from '../Charts/Legend/Legend'
import LegendList from '../Charts/Legend/LegendList'
import NoData from '../NoData/NoData';
import CommonTable from '../Table/CommonTable';
import { urlConstants } from '../../constants/urlConstants';
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from '../Cards/CustomButtons';
import { staticNotes } from '../../constants/staticNotes';
import DropdownWithIcons from './DropdownWithIcons';

import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
// import WorldMap from '../WorldMap/WorldMap'
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
import EDF_checked from "../../../src/assets/EDF_checked.svg";

import { toast } from "react-toastify";
import CompassStackedChart from '../Charts/CompassChart/CompassStackedChart';

const priceChartColors = [
    { name: "Round 1 -> 2", color: "#33ABDA", key: "round1To2" },
    { name: "Round 2 -> 3", color: "#B05788", key: "round2To3" },
    { name: "Round 3 -> 4", color: "#0078A7", key: "round3To4" },
    { name: "Round 4 -> 5", color: "#8458CC", key: "round4To5" },
    { name: "Round 5 -> 6", color: "#3A3A3A", key: "round5To6" },
    { name: "Round 6 -> 7", color: "#994900", key: "round6To7" }
]


const cellDataFunction = (ctx) => {
    const colId = ctx.column.id
    const percentage = ctx.row.original[colId]
    return (
        <div style={{ textAlign: 'left', paddingLeft: 15 }}>{percentage}</div>
    )
}

const columns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'projectName', header: 'Project Name', columnAlignment:'center', cellData: cellDataFunction, size: 500, minSize: 500, maxSize: 500 },
    { columnKey: 'projectStatus', header: 'Bid status', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'bidInitiator', header: 'Bid Initiator', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'l0Category', header: 'Category L0', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'l1Category', header: 'Category L1', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'l2Category', header: 'Category L2', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'sector', header: 'Sector', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'bu', header: 'BU / Market', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    // {
    //   columnKey: 'smartCubeCategoryWithLink',
    //   header: 'Respective SmartCube Categories',
    //   cellData: (ctx) => {
    //     const smartCubeCategoryWithLink = ctx.row.original.smartCubeCategoryWithLink;
    //     const smartCubeSector = ctx.row.original.smartCubeSector
    //     const nameAndLink = smartCubeCategoryWithLink?.split("$$");
    //     return <a href={nameAndLink[1]} target="_blank" style={{display:"flex",textDecoration:"none",color:"#005CBC"}}><span style={{textDecoration:"none"}}>{smartCubeSector} - {nameAndLink[0]}</span><Icon alt="" icon="open_in_new" size="small" /></a>
    //   },
    // }
];




const MODAL_TITLE = 'Sourcing(Launch RFx, Negotiation)';

function ArchletModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters, appName }) {
    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);


    const handleClose = () => {
        try {
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        setDataLoadActionType("");
        setOpenModal(false);
    };
    const [archletData, setArchletData] = useState({})
    const [loader, setLoader] = useState(true)
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const [dataLoadActionType, setDataLoadActionType] = useState("");

    // const appOwnersList = archletData?.owners
    // const emailList = appOwnersList?.map(contact => contact.emailId).join(', ');


    const getArchletDataFromFilters = (value) => {
        let appList = [];
        if(value?.data?.type==="SUCCESS_ARCHLET_DETAIL_VIEW_ACTION") {
            
            setArchletData(value.data)
            setLoader(value.loader);
            setDataLoadActionType(value?.data?.type)
            appList = value.data?.apps;
        }

        if (value.modalName == "Archlet" && appList && appList.length > 0) {
            const tempbuttonGroupItems = [
                { 
                    icon: "ondemand_video", 
                    label: "", 
                    onClick: () => window.open(urlConstants.archletVideo, "_blank") 
                },
                // Fallback to [] ensures the spread operator doesn't fail on undefined
                ...(appList
                    ?.filter(item => item.isActive)
                    .map(item => ({
                        label: item.app,
                        onClick: () => window.open(item.url, "_blank"),
                    })) ?? []) 
            ];
            setButtonGroupItems(tempbuttonGroupItems)
        }
    }

    const e2eBidEvents = archletData?.bidEventDtoList;
    const lineChartDtoList = archletData?.lineChartDtoList
    const stackedBarDetails = archletData?.stackedBarDetails
    const priceChangeChartColors = archletData?.averagePriceChangeDto
    const categoriesWithColor = archletData?.categoriesWithColor
    const totalBidEvents = archletData?.headerRowDetailsDto?.totalBidEvents
    const totalSkusRequested = archletData?.headerRowDetailsDto?.totalSkusRequested
    const scenariosCreated = archletData?.headerRowDetailsDto?.scenariosCreated
    const offersReceivedAgainstTotalSkus = splitNumericValue(archletData?.headerRowDetailsDto?.offersReceivedAgainstTotalSkus)
    const hoursSaved = archletData?.headerRowDetailsDto?.hoursSaved
    const e2eBidsLaunchedThroughArchlet = archletData?.headerRowDetailsDto?.e2eBidsLaunchedThroughArchlet
    const avgHoursSavedOnRFP = archletData?.headerRowDetailsDto?.avgHoursSavedOnRFP
    const isEDFIntegrated = archletData?.edfintegrated;

    const filteredPriceChartColors = priceChartColors.filter(item => priceChangeChartColors?.[item.key] !== null);

    // Define the columns to keep and the desired order
    const columnsToInclude = ['PROJECT NAME',
    'BID STATUS',
    'BID INITIATOR',
    'CATEGORY L0',
    'CATEGORY L1',
    'CATEGORY L2',
    'SECTOR',
    'BU / MARKET',
    ]; // Use uppercase for final header names
    const columnMapping = {
        "projectName": "PROJECT NAME",
        "projectStatus": "BID STATUS",
        "sector": "SECTOR",
        "bu": "BU / MARKET",
        "l0Category": "CATEGORY L0",
        "l1Category": "CATEGORY L1",
        "l2Category": "CATEGORY L2",
        "bidInitiator": "BID INITIATOR"
};

const archletModalRef = useRef()
const totalBidEventsHoursSavedChartRef = useRef();
const averagePriceChangebyRoundsChartRef = useRef();
const totalBidEventsStackedBarChartRef = useRef();


const { showToast } = useToast();


const checkPDFDownloaded = () => {}

// const checkPDFDownloaded = (isPdfDownloaded, isModal, fileURL, isExcel, isTable, isJpeg) => {
//     if(isPdfDownloaded){
//         if(isModal){
//             showToast('success', !isJpeg ? "PDF of full page successfully downloaded." : 'JPEG of full page successfully downloaded.', {
//                 icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
//             });
//         } else if(isTable){
//             showToast('success', !isJpeg ? "PDF of a table successfully downloaded." : 'JPEG of a table successfully downloaded.', {
//                 icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
//             });
//         }
//         else{
//             showToast('success', !isJpeg ? "PDF of a chart successfully downloaded.": 'JPEG of a chart successfully downloaded.', {
//                 icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
//             });
//         }
       

//     }
//     else{
//         showToast('Error', "Failed to download. Please try again.", {
//             icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
//         });
//     }   
//   }




const handleClick =() => {
    console.log('In modal click')
}
    
    return (
        <Modal
            // onClick={(e) => e.stopPropagation()}
            closeOnOutsideClick={false}
            // onClick={handleClick}
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            <div ref={archletModalRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData?.FirstName}, bid events through Archlet for your category are <b>{totalBidEvents ? totalBidEvents : 0}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>        
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                size="small"
                            /> */}
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons 
                                    isModal={true} 
                                    appList={[
                                        { 
                                        icon: 'ondemand_video', 
                                        label: '', 
                                        url: "https://pepsico.sharepoint.com/:v:/r/teams/DigitalProcurement-BuyersConsolePOC/Shared%20Documents/General%20-/Workstream%20Documentation/Background,%20Discovery%20%26%20Requirements/App%20Videos/Archlet%20Video.mp4?csf=1&web=1&e=bmPOGj", 
                                        },
                                        ...(Array.isArray(archletData?.apps) ? archletData.apps : [])
                                    ]}   
                                />

                                {/* <button onClick={handleDomToImgDownloadPdf}>PDF</button> */}
                        
                                <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                    <DropdownWithIcons modalRef={archletModalRef} kpiName={"Archlet_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                </span>

                            </span>
                       
                       
                       
                        </>
                    }
                </div>
                <div className="modal-update-frequesncy" style={{ marginBottom: "10px", display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {staticNotes.ARCHLET_BU_NOTE}</div>
                {(archletData?.lastUpdate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(archletData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(archletData?.refreshFrequency)}</div>}
                <ModalFilters modalName={"Archlet"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getArchletDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} appName={appName} />
                <br />

                {/* <WorldMap/> */}
                {
                    (loader || isLoading) ? // dataLoadActionType!=="SUCCESS_ARCHLET_DETAIL_VIEW_ACTION" || 
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                                <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%',display:'flex' }}>
                                    <div className='header-kpi-wrapper'>
                                    {
                                        totalBidEvents !== undefined || totalBidEvents !== null ?
                                            <>
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="archlet-modal-alphanumeric-value">
                                                            <div className="archlet-modal-header-kpi">{totalBidEvents ? formatNumberWithCommas(totalBidEvents) : 0}</div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Total Bid Events</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }

                                    {
                                        hoursSaved !== undefined || hoursSaved !== null ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="archlet-modal-alphanumeric-value">
                                                            <div className="archlet-modal-header-kpi">{hoursSaved ? hoursSaved : 0}</div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Hours Saved</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }
                                    {
                                        avgHoursSavedOnRFP !== undefined || avgHoursSavedOnRFP !== null ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="archlet-modal-alphanumeric-value">
                                                            <div className="archlet-modal-header-kpi">{avgHoursSavedOnRFP ? avgHoursSavedOnRFP : 0}</div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Avg. Hours Saved on each Bid Event</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }
                                    {
                                        totalSkusRequested !== undefined || totalSkusRequested !== null ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="archlet-modal-alphanumeric-value">
                                                            <div className="archlet-modal-header-kpi">{totalSkusRequested ? formatNumberWithCommas(totalSkusRequested) : 0}</div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Total SKUs Requested</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }
                                    {
                                        scenariosCreated !== undefined || scenariosCreated !== null ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="archlet-modal-alphanumeric-value">
                                                            <div className="archlet-modal-header-kpi">{scenariosCreated ? scenariosCreated : 0}</div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Scenarios Created</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }
                                    {
                                        offersReceivedAgainstTotalSkus?.value !== undefined || offersReceivedAgainstTotalSkus?.value !== null ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="archlet-modal-alphanumeric-value">
                                                            <div className="archlet-modal-header-kpi">{offersReceivedAgainstTotalSkus.value || 0}{offersReceivedAgainstTotalSkus.suffix || ''}</div>
                                                            {/* <div className="archlet-modal-header-unit"></div> */}
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Offers Received Against Total SKUs</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }

                                    {
                                        e2eBidsLaunchedThroughArchlet !== undefined || e2eBidsLaunchedThroughArchlet !== null ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="archlet-modal-alphanumeric-value">
                                                            <div className="archlet-modal-header-kpi">{e2eBidsLaunchedThroughArchlet ? e2eBidsLaunchedThroughArchlet : 0}</div>
                                                            <div className="archlet-modal-header-unit"></div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>E2E bids launched through Archlet</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }
                                    </div>
                                </Card>
                                </Col> 
                                </Row>
                            </div>
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <div ref={totalBidEventsHoursSavedChartRef}>
                                    <Card style={{ height: '100%' }} className="archlet-chart-card">
                                        <div className="archlet-chart-title" >
                                            Total Bid Events vs Hours Saved
                                            <span style={{float: 'right'}}>
                                                <DropdownWithIcons modalRef={totalBidEventsHoursSavedChartRef} kpiName={"Total Bid Events vs Hours Saved"} checkPDFDownloaded={checkPDFDownloaded}/>
                                            </span>
                                        </div>
                                        {
                                            // lineChartDtoList?.length > 0 ?
                                            totalBidEvents ?
                                                <>
                                                    <ArchletLineChart data={lineChartDtoList} />
                                                    {/* <Legend title1={"Total Bid Events"} title2={"Hours Saved"} /> */}
                                                    <LegendList legends={[
                                                                    { name: 'Total Bid Events', color: '#0078A7'},
                                                                    { name: 'Hours Saved', color:"#B05788"},
                                                    ]}/>
                                                </> : <NoData />
                                        }
                                    </Card>
                                </div>
                                </Col><br />
                                {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                    <Card style={{ height: '100%' }}>
                                        <ArchletStackedBarChart categories={categoriesWithColor} data={stackedBarDetails} />
                                        <LegendList legends={categoriesWithColor} />
                                    </Card>
                                </Col> */}
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <div ref={averagePriceChangebyRoundsChartRef}>
                                    <Card style={{ height: '100%' }} className="archlet-chart-card">
                                        <div className="archlet-chart-title" >
                                            % Average Price Change by Rounds
                                            <span style={{float: 'right'}}>
                                                <DropdownWithIcons modalRef={totalBidEventsHoursSavedChartRef} kpiName={"% Average Price Change by Rounds"} checkPDFDownloaded={checkPDFDownloaded}/>
                                            </span>
                                        </div>
                                        {
                                            priceChangeChartColors && Object.values(priceChangeChartColors)?.some((value) => value !== null && value !== undefined && value !== '') ?
                                                <>
                                                    <PriceChangeBarChart averagePriceChangeDto={priceChangeChartColors} />
                                                    <LegendList legends={filteredPriceChartColors} />
                                                </> : <NoData />
                                        }
                                    </Card>
                                </div>
                                </Col>
                                <br />

                            </Row>
                            <br />
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div ref={totalBidEventsStackedBarChartRef}>
                                    <Card style={{ height: '100%' }}>
                                        <div className="archlet-chart-title" >
                                            Total Bid Events
                                            <span style={{float: 'right'}}>
                                                <DropdownWithIcons modalRef={totalBidEventsStackedBarChartRef} kpiName={"Total Bid Events"} checkPDFDownloaded={checkPDFDownloaded}/>
                                            </span>
                                        </div>
                                        {
                                            stackedBarDetails?.length > 0 ?
                                                <>
                                                    {/* <ArchletStackedBarChart categories={categoriesWithColor} data={stackedBarDetails} /> */}
                                                    <CompassStackedChart categories={categoriesWithColor} data={stackedBarDetails} isArchlet={true} />
                                                    <LegendList legends={categoriesWithColor} />
                                                </> : <NoData />
                                        }
                                    </Card>
                                </div>
                                </Col>
                            </Row>
                            <br />
                            <br />
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    
                                    {
                                        e2eBidEvents && e2eBidEvents?.length > 0 ?
                                            // <ArchletTable data={e2eBidEvents} /> 
                                            <div className="ph-table-wrapper">
                                                <CommonTable className="archlet-table" data={e2eBidEvents} columns={columns} tableHeader="Bid Events" enableSorting={true} columnsToInclude={columnsToInclude} columnMapping={columnMapping} tableName={'BID EVENTS'}/>
                                            </div>
                                            : <Card style={{ height: '100%' }}><NoData /></Card>
                                    }
                                </Col>
                            </Row>
                            <br />


                            <br />

                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {
                                    archletData?.owners?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {archletData?.owners?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < archletData?.owners?.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </>
                }
                <br/>
            </div>
        </Modal>
    )
}

export default ArchletModal